import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import type { ReactNode } from "react";

import {
  dangerZoneActionButtonWidthPx,
  dangerZoneConfirmFieldWidthPx,
  settingsDangerZonePanelSx
} from "~/features/settings/settings.styles";

import { SettingsSectionWrapper } from "./SettingsSection";

type DangerZoneWrapperProps = {
  title: string;
  children: ReactNode;
};

export function DangerZoneWrapper(props: DangerZoneWrapperProps) {
  const { title, children } = props;
  return (
    <SettingsSectionWrapper title={title}>
      <Stack spacing={2} sx={{ width: "100%" }}>
        {children}
      </Stack>
    </SettingsSectionWrapper>
  );
}

export type SettingsDangerZoneRowProps = {
  title: string;
  hint: string;
  confirmationPhrase: string;
  confirmationValue: string;
  onConfirmationChange: (value: string) => void;
  actionLabel: string;
  onAction: () => void;
  fieldDisabled?: boolean;
  actionDisabled?: boolean;
};

export function SettingsDangerZoneRow(props: SettingsDangerZoneRowProps) {
  const {
    title,
    hint,
    confirmationPhrase,
    confirmationValue,
    onConfirmationChange,
    actionLabel,
    onAction,
    fieldDisabled,
    actionDisabled
  } = props;

  const textFieldSx = {
    width: dangerZoneConfirmFieldWidthPx,
    flexShrink: 0,
    "& .MuiInputBase-root": { width: "100%" }
  };

  const buttonSx = {
    width: dangerZoneActionButtonWidthPx,
    minWidth: dangerZoneActionButtonWidthPx,
    flexShrink: 0,
    boxSizing: "border-box" as const
  };

  return (
    <Box sx={(theme) => settingsDangerZonePanelSx(theme)}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ sm: "center" }}
        justifyContent="space-between"
      >
        <Stack spacing={0.5} flex={1}>
          <Typography variant="body2" fontWeight={600}>
            {title}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {hint}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <TextField
            size="small"
            placeholder={confirmationPhrase}
            value={confirmationValue}
            onChange={(e) => onConfirmationChange(e.target.value)}
            disabled={fieldDisabled}
            sx={textFieldSx}
            inputProps={{
              "aria-label": confirmationPhrase
            }}
          />
          <Button
            color="error"
            variant="contained"
            size="small"
            disabled={actionDisabled}
            onClick={onAction}
            sx={buttonSx}
          >
            {actionLabel}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
